@if (_link && label) {
  <a [href]="_link">{{label}}</a>
}
